import React from 'react';
import sharedStyles from './Modals.module.css';
import styles from './RushQAReviewModal.module.css';

const RushQAReviewModal = ({ watchedSeconds, episodeDurationSeconds, onClose }) => {
    const minSeconds = (episodeDurationSeconds !== null && episodeDurationSeconds !== undefined && episodeDurationSeconds < 30)
        ? episodeDurationSeconds
        : 30;
    const isShortEpisode = minSeconds < 30;

    const capped = Math.min(watchedSeconds, minSeconds);
    const pct = Math.round((capped / minSeconds) * 100);

    const elapsedMin = Math.floor(capped / 60);
    const elapsedSec = Math.floor(capped % 60);
    const elapsedDisplay = `${elapsedMin}:${String(elapsedSec).padStart(2, '0')}`;
    const totalMin = Math.floor(minSeconds / 60);
    const totalSec = Math.floor(minSeconds % 60);
    const totalDisplay = `${totalMin}:${String(totalSec).padStart(2, '0')}`;
    const remaining = Math.ceil(minSeconds - watchedSeconds);

    return (
        <div className={sharedStyles.overlay}>
            <div className={styles.shell}>

                <div className={styles.header}>
                    <div className={styles.headerIcon}>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <circle cx="8.5" cy="8.5" r="6" stroke="#e05555" strokeWidth="1.3" />
                            <path d="M8.5 5v4M8.5 11v.5" stroke="#e05555" strokeWidth="1.3" strokeLinecap="round" />
                        </svg>
                    </div>
                    <div className={styles.headerText}>
                        <div className={styles.title}>You need more time on this episode</div>
                        <div className={styles.subtitle}>Accurate reviews take time. Please watch the full episode before submitting your scores.</div>
                    </div>
                </div>

                <div className={styles.body}>

                    <div className={styles.ruleBox}>
                        <span className={styles.ruleIcon}>&#9432;</span>
                        <span className={styles.ruleText}>
                            {isShortEpisode ? (
                                <><strong>You must watch the full episode before submitting ({minSeconds}s).</strong> This episode is shorter than 30 seconds. Watch it completely before scoring. Rushed reviews affect your accuracy score.</>
                            ) : (
                                <><strong>A minimum of 30 seconds is required per episode.</strong> This ensures validators have enough time to properly assess the footage before scoring. Rushed reviews affect your accuracy score.</>
                            )}
                        </span>
                    </div>

                    <div className={styles.timerSection}>
                        <div className={styles.timerHeader}>
                            <span className={styles.timerLabel}>Time watched on this episode</span>
                            <span className={styles.timerCount}>{elapsedDisplay} / {totalDisplay}</span>
                        </div>
                        <div className={styles.timerTrack}>
                            <div className={styles.timerFill} style={{ width: `${pct}%` }} />
                        </div>
                        {watchedSeconds === 0 ? (
                            <span className={styles.timerSub}>Press play to start watching the episode</span>
                        ) : (
                            <span className={styles.timerSub}>{remaining} second{remaining === 1 ? '' : 's'} remaining before you can proceed</span>
                        )}
                    </div>

                    <div className={styles.actions}>
                        <button type="button" className={styles.stayBtn} onClick={onClose}>
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M2 6l3 3 5-5.5" stroke="#111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            Keep watching
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default RushQAReviewModal;
